import loadable from '@loadable/component';
import { Loader } from '@/components';

export const AsyncAdditionalAmountApproved = loadable(
  () => import('./AdditionalAmountApproved'),
  {
    fallback: <Loader />,
  },
);
